import * as CONSTS from "../../assets/consts";
import { translate } from "../locales/translate";
import * as faCharCodes from "../../assets/consts/faCharCodes";

class ScenarioCondition {
  constructor(baseType, isMain, customId = 0, customUId = null) {
    this.id = customId;
    this.uId = customUId;
    this.tempId = customId > 0 ? customId : `new_${new Date().getTime()}`;
    this.isMain = isMain;
    this.baseType = baseType; // for example schedule_daily, timeRange, etc...
    this.getSummary = () => {
      return translate(`scenario.summary.noSummary`, { type: this.baseType });
    };
  }
}

export class ScenarioScheduleCondition extends ScenarioCondition {
  constructor(baseType, customId = 0, customUId = null) {
    super(baseType, true, customId, customUId);
    this.time = "";
    this.scheduleType = "daily"; // default is daily. allowed values: daily, custom
    this.scheduleDaysOfWeek = "";
    this.customRepeatType = "day"; //default is day. allowed values : day, hour, minute
    this.customRepeatInterval = 0;
    this.getSummary = () => {
      // console.log("ScenarioScheduleCondition.getSummary() for", this);
      if (this.scheduleType.toLowerCase() == "daily") {
        var daysArray = Array.isArray(this.daysOfWeek)
          ? this.daysOfWeek
          : this.daysOfWeek
          ? this.daysOfWeek.split(",")
          : this.scheduleDaysOfWeek
          ? this.scheduleDaysOfWeek.split(",")
          : [];

        if (daysArray.length == 7 || daysArray.length == 0) {
          return translate(`scenario.summary.dailyScheduleEveryDay`, {
            time: this.time || this.time,
          });
        } else {
          return translate(`scenario.summary.dailySchedule`, {
            time: this.time || this.time,
            days: daysArray.map((d) => translate(`week.${d}`)).join(", "),
          });
        }
      } else if (this.scheduleType.toLowerCase() == "custom") {
        return translate(`scenario.summary.customSchedule`, {
          time: this.time,
          repeatType: translate(`app.${this.customRepeatType}`),
          interval: this.customRepeatInterval,
        });
      } else {
        return translate(`scenario.summary.noSummary`, { type: this.baseType });
      }
    };
  }
}

export class ScenarioTimeRangeCondition extends ScenarioCondition {
  constructor(customId = 0, customUId = null) {
    super(
      CONSTS.SCENARIO_CONDITIONS.OPTIONAL_TIME_RANGE,
      false,
      customId,
      customUId
    );
    this.timeStateStart = "";
    this.timeStateEnd = "";
    this.checkAfterDelay = false;
    this.getSummary = () => {
      // console.log("ScenarioTimeRangeCondition.getSummary() for", this);
      var _s = this.timeStateStart || this.startTime;
      var _e = this.timeStateEnd || this.endTime;
      if (!_s && !_e) {
        return "no time specified";
      }
      if (!_e) {
        return translate(`scenario.summary.timeRangeWithStart`, {
          start: _s,
        });
      } else if (!_s) {
        return translate(`scenario.summary.timeRangeWithEnd`, {
          end: _e,
        });
      } else {
        return translate(`scenario.summary.timeRange`, {
          start: _s,
          end: _e,
        });
      }
    };
  }
}
/**main condition */
export class ScenarioDeviceEventCondition extends ScenarioCondition {
  constructor(customId = 0, customUId = null) {
    super(CONSTS.SCENARIO_CONDITIONS.MAIN_DEVICE, true, customId, customUId);
    this.deviceType = "";
    this.deviceId = 0;
    this.deviceUId = "";
    this.deviceName = "";
    this.areaId = 0;
    this.areaUId = "";
    this.areaName = "";
    this.listenerName = "";
    this.eventName = "";
    this.eventType = "void"; // void | bool | byte
    this.minExpectedRange = null;
    this.maxExpectedRange = null;
    this.expectedBinaryValue = true;
    this.parameterNames = [];
    this.parameterTypes = [];
    this.parameterValues = [];
    this.ignoreEventsIntervalValue = 0;
    this.ignoreEventsIntervalType = "second";
    this.getSummary = () => {
      // console.log("ScenarioDeviceEventCondition.getSummary() for", this);

      var result =
        translate(`scenario.${this.listenerName}`) +
        " " +
        (this.deviceName || this.areaName || "") +
        " " +
        translate(`scenario.${this.eventName}`) +
        " ";

      if (
        this.parameterNames.length > 0 &&
        this.parameterNames.length == this.parameterValues.length
      ) {
        var paramReports = [];
        for (const i in this.parameterNames) {
          var pn = translate(`scenario.${this.parameterNames[i]}`);
          var pv = this.parameterValues[i];
          paramReports.push(`${pn}: ${pv}`);
        }

        result += ` (${paramReports.join(", ")})`;
      }
      return result;
    };
  }
}

/**optional condition */
export class ScenarioDeviceStateCondition extends ScenarioCondition {
  constructor(customId = 0, customUId = null) {
    super(
      CONSTS.SCENARIO_CONDITIONS.OPTIONAL_DEVICE_STATE,
      false,
      customId,
      customUId
    );
    this.deviceType = "";
    this.deviceId = 0;
    this.deviceUId = "";
    this.deviceName = "";
    this.areaId = 0;
    this.areaUId = "";
    this.areaName = "";
    this.listenerName = "";
    this.stateName = "";
    this.argNames = [];
    this.argValues = [];
    this.checkAfterDelay = false;

    this.getSummary = () => {
      var result = `${this.areaName} > `;
      result += translate(`scenario.${this.listenerName}`);
      if (this.deviceName) {
        result += ` > ${this.deviceName}`;
      }
      result += ` > `;
      result += translate(`scenario.${this.stateName}`);
      if (this.argNames.length > 0) {
        var _argsSummary = "";
        for (var i in this.argNames) {
          switch (this.argNames[i]) {
            case "temperature":
              _argsSummary += `${translate("scenario.temperature")}: ${
                this.argValues[i]
              }${translate("scenario.stateParamUnits.temperature")} `;
              break;
            case "value":
              _argsSummary += `${translate("scenario.value")}: ${
                this.argValues[i]
              } `;
              break;
            case "tolerance":
              if (this.argValues[i] > 0) {
                _argsSummary += `${translate(
                  "scenario.withTolerance"
                )} ${translate("scenario.stateParamUnits.tolerance")} ${
                  this.argValues[i]
                }`;
              }
              break;
            case "min":
              _argsSummary += `${this.argValues[i]} ${translate(
                "scenario.orAbove"
              )}`;
              break;
            case "max":
              _argsSummary += `${translate("scenario.lessThan")} ${
                this.argValues[i]
              }`;
              break;
            default:
              break;
          }
        }
        result += ` > `;
        result += _argsSummary;
      }
      return result;
    };
  }
}

export class ScenarioArmedCondition extends ScenarioCondition {
  constructor(baseType, customId = 0, customUId = null) {
    super(baseType, false, customId, customUId);
    this.areaIdArmCheck = 0;
    this.areaUIdArmCheck = "";
    this.areaNameArmCheck = "";
    this.areaArmCheckExpected = false;
    this.checkAfterDelay = false;
    this.getSummary = () => {
      // console.log("ScenarioArmedCondition.getSummary() for", this);

      return translate(`scenario.summary.areaArmed`, {
        area: this.areaNameArmCheck || this.areaName,
        not: this.areaArmCheckExpected ? "" : translate(`scenario.summary.not`),
      });
    };
  }
}

export class ScenarioUserDefinedStateCondition extends ScenarioCondition {
  constructor(baseType, customId = 0, customUId = null) {
    super(baseType, false, customId, customUId);
    this.areaId = 0;
    this.areaUId = "";
    this.areaName = "";
    this.stateId = false;
    this.stateUId = null;
    this.stateName = "";
    this.expectedActivation = true;
    this.checkAfterDelay = false;
    this.getSummary = () => {
      // console.log("ScenarioArmedCondition.getSummary() for", this);

      return translate(`scenario.summary.areaUserDefinedState`, {
        area: this.areaName,
        state: this.stateName,
        not: this.expectedActivation ? "" : translate(`scenario.summary.not`),
      });
    };
  }
}

export class ScenarioVirtual extends ScenarioCondition {
  constructor(customId = 0, customUId = null) {
    super(CONSTS.SCENARIO_CONDITIONS.MAIN_VIRTUAL, true, customId, customUId);
    this.iconName = "question";

    this.getSummary = () => {
      // console.log("ScenarioVirtual.getSummary() for", this);

      return "";
    };
  }
}

export class ScenarioAction {
  constructor(customId = 0, customUId = null) {
    this.id = customId;
    this.uId = customUId;
    this.tempId = customId > 0 ? customId : `new_${new Date().getTime()}`;
    this.areaId = 0;
    this.areaUId = "";
    this.areaName = "";
    /**example: "LightManager" */
    this.manager = "";
    /**
     * example: "TurnAllOn"
     */
    this.action = "";
    /** list of dataTypes of values. example : ["bool"] | ["byte"] | [] */
    this.parameterTypes = [];
    this.parameterNames = [];
    /**real values. should match types. example : [true]   | [125]    | [] */
    this.parameters = [];
    this.parametersAlt = [];
    this.deviceId = 0;
    this.deviceUId = "";
    this.deviceName = "";
    this.order = 0;

    this.setParameterAlt = (index = -1, alt = "") => {
      if (!Array.isArray(this.parametersAlt)) {
        this.parametersAlt = [];
      }

      if (index >= 0 && index < this.parameters) {
        this.parametersAlt[index] = alt;
      }
    };

    this.getSummary = (isReverse = false, dictionary = []) => {
      // dictionary must be an array of {manager: "managerName" , action : "actionName" , reverse : "reverseActionName"}
      // console.log("ScenarioAction.getSummary() for", this);
      var reverseAction = undefined;
      if (isReverse && Array.isArray(dictionary)) {
        var d = dictionary.filter(
          (d) => d.manager == this.manager && d.action == this.action
        )[0];
        if (d) reverseAction = d.reverse;
      }
      if (this.deviceId || this.deviceUId) {
        var _parameterValues = this.parameters;
        //if(this.manager == "ElevatorManager" && this.action == "SendToFloor"){
        if (this.parametersAlt && this.parametersAlt.length > 0) {
          _parameterValues = this.parametersAlt;
        }
        return translate(`scenario.summary.actionSingleDeviceSummary`, {
          area: this.areaName,
          manager: translate(`scenario.${this.manager}`),
          action: isReverse
            ? translate(`scenario.${reverseAction}`)
            : translate(`scenario.${this.action}`),
          parameters:
            _parameterValues.length > 0 // && this.parameterNames.length > 0
              ? `(${_parameterValues.join(", ")})`
              : "",
          device: this.deviceName,
        });
      } else {
        return translate(`scenario.summary.actionBatchSummary`, {
          area: this.areaName,
          manager: translate(`scenario.${this.manager}`),
          action: isReverse
            ? translate(`scenario.${reverseAction}`)
            : translate(`scenario.actionsList.${this.action}`),
        });
      }
    };
  }
}

export class ScenarioAreaStateAction {
  constructor(customId = 0) {
    this.id = 0;
    this.uId = null;
    this.tempId = customId > 0 ? customId : `new_${new Date().getTime()}`;
    this.areaId = 0;
    this.areaUId = null;
    this.areaName = "";
    this.stateId = 0;
    this.stateUId = null;
    this.stateName = "";
    this.action = "";
    this.manager = "AreaStateManager";
    this.autoDisableIntervalType = "second";
    this.autoDisableIntervalDuration = 0;
    this.shouldOverrideAutoDisable = false;
    this.order = 0;
    this.getSummary = (isReverse = false, dictionary = []) => {
      // if (isReverse && this.manager !== "AreaStateManager") return "";

      var reverseAction = undefined;
      if (isReverse && Array.isArray(dictionary) && dictionary.length !== 0) {
        var d = dictionary.filter(
          (d) => d.manager == this.manager && d.action == this.action
        )[0];
        if (d) reverseAction = d.reverse;
      }
      if (this.shouldOverrideAutoDisable) {
        return translate("areaState.activateStateInAreaLimited", {
          area: this.areaName,
          state: this.stateName,
          duration: this.autoDisableIntervalDuration,
          intervalType: translate(`timer.${this.autoDisableIntervalType}`),
          action:
            translate(`scenario.actionsList.${this.action}`) ||
            translate(`scenario.actionsList.Activate`),
        });
      } else if (
        isReverse &&
        // this.manager == "AreaStateManager"
        reverseAction
      ) {
        return translate("areaState.activateStateInArea", {
          area: this.areaName,
          state: this.stateName,
          duration: this.autoDisableIntervalDuration,
          intervalType: translate(`timer.${this.autoDisableIntervalType}`),
          action:
            translate(`scenario.actionsList.${reverseAction}`) ||
            translate(`scenario.actionsList.Activate`),
        });
      } else {
        return translate("areaState.activateStateInArea", {
          area: this.areaName,
          state: this.stateName,
          action:
            translate(`scenario.actionsList.${this.action}`) ||
            translate(`scenario.actionsList.Activate`),
        });
      }
    };

    this.updateAutoDisable = (
      shouldOverrideAutoDisable = false,
      autoDisableIntervalDuration = 0,
      autoDisableIntervalType = "second"
    ) => {
      this.shouldOverrideAutoDisable = shouldOverrideAutoDisable;
      this.autoDisableIntervalDuration = autoDisableIntervalDuration;
      this.autoDisableIntervalType = autoDisableIntervalType;
    };
  }

  static parse(obj) {
    var result = new ScenarioAreaStateAction();
    Object.assign(result, { ...obj });

    return result;
  }
}

export class ScenarioRunScenarioAction {
  constructor(
    scenarioId = 0,
    scenarioUId = null,
    scenarioName = "",
    reverseEnabled = false,
    customId = 0
  ) {
    this.id = customId;
    this.tempId = customId > 0 ? customId : `new_${new Date().getTime()}`;
    this.scenarioToRunId = scenarioId;
    this.scenarioToRunUId = scenarioUId;
    this.scenarioName = scenarioName;
    this.reverseEnabled = reverseEnabled;
    this.order = 0;
    this.getSummary = () => {
      if (this.scenarioToRunId || this.scenarioToRunUId) {
        return this.scenarioName;
      } else {
        return "";
      }
    };
  }
}

export class ScenarioIconProvider {
  getAllV6 = () => {
    return [
      faCharCodes.faHandPointUp,
      faCharCodes.faLightbulb,
      faCharCodes.faLightbulbDollar,
      faCharCodes.faLightbulbExclamation,
      faCharCodes.faLightbulbOn,
      faCharCodes.faLightbulbSlash,
      faCharCodes.faPowerOff,
      faCharCodes.faPlug,
      faCharCodes.faDotCircle,
      faCharCodes.faBolt,
      faCharCodes.faMusic,
      faCharCodes.faVolumeMute,
      faCharCodes.faPlayCircle,
      faCharCodes.faCheckCircle,
      faCharCodes.faPlusCircle,
      faCharCodes.faMinusCircle,
      faCharCodes.faAdjust,
      faCharCodes.faBell,
      faCharCodes.faBellSlash,
      faCharCodes.faLeaf,
      faCharCodes.faSun,
      faCharCodes.faStar,
      faCharCodes.faCertificate,
      faCharCodes.faMoon,
      faCharCodes.faTint,
      faCharCodes.faFire,
      faCharCodes.faWind,
      faCharCodes.faTrash,
      faCharCodes.faLock,
      faCharCodes.faLockOpen,
      faCharCodes.faLockOpenAlt,
      faCharCodes.faShieldAlt,
      faCharCodes.faShield,
      faCharCodes.faShieldCheck,
      faCharCodes.faShieldCross,
      faCharCodes.faDoorOpen,
      faCharCodes.faDoorClosed,
      faCharCodes.faPortalEnter,
      faCharCodes.faPortalExit,
      faCharCodes.faSignIn,
      faCharCodes.faSignInAlt,
      faCharCodes.faSignOut,
      faCharCodes.faSignOutAlt,
      faCharCodes.faParking,
    ];
  };
}

export default class Scenario {
  constructor() {
    this.id = 0;
    this.uId = null;
    this.name = "";
    this.nameShortcutBoard = "";
    this.enable = true;
    this.delayMillisecond = undefined;
    this._mainConditionType = "";
    this.conditions = [];
    this.actions = [];
    this.areaStateActions = [];
    this.runScenarioActions = [];
    // this.notifications = [];
    this.compositionType = "";
    this.afterDelayCompositionType = "";

    this.rolesAllowedExecute = "Admin";
    this._allowedRoles = ["Admin"];

    this.rolesReceiveNotification = "Me";
    this._rolesReceiveNotification = ["Me"];

    this.showDashboardShortcut = false;

    this.reverseEnabled = false;
    this.reverseIntervalValue = 0;
    this.reverseIntervalType = "second";

    // add other type of notifications in hasNotification() func.
    this.notifyBySms = false;
    this.notifyByPushNotification = false;

    this.notificationCustomMessage = "";
    this.notificationReverseCustomMessage = "";

    // existed items marked as removed
    this.removedItems = [];

    this.hasDetail = false;
  }

  setShowDashboardShortcut(v) {
    this.showDashboardShortcut = v === true; // will return false in case of invalid types like empty string
  }

  AddAllowedRole(roleName) {
    if (this._allowedRoles.indexOf(roleName) < 0) {
      this._allowedRoles.push(roleName);
      this.rolesAllowedExecute = this._allowedRoles.join(",");
    }
  }

  RemoveAllowedRole(roleName) {
    // admin can not be removed at all
    if (roleName == "Admin") {
      return;
    }
    var idx = this._allowedRoles.indexOf(roleName);
    if (idx >= 0) {
      this._allowedRoles.splice(idx, 1);
      this.rolesAllowedExecute = this._allowedRoles.join(",");
    }
  }

  AddNotificationReceiverRole(roleName) {
    if (this._rolesReceiveNotification.indexOf(roleName) < 0) {
      this._rolesReceiveNotification.push(roleName);
      this.rolesReceiveNotification = this._rolesReceiveNotification.join(",");
    }
  }

  setNotificationCustomMessage(message) {
    this.notificationCustomMessage = message;
  }

  setNotificationReverseCustomMessage(message) {
    this.notificationReverseCustomMessage = message;
  }

  RemoveNotificationReceiverRole(roleName) {
    var idx = this._rolesReceiveNotification.indexOf(roleName);
    if (idx >= 0) {
      this._rolesReceiveNotification.splice(idx, 1);
      this.rolesReceiveNotification = this._rolesReceiveNotification.join(",");
    }
  }

  getMainCondition() {
    if (this.conditions.length > 0) {
      for (var i in this.conditions) {
        if (this.conditions[i].isMain) {
          var result = this.conditions[i];
          switch (this._mainConditionType) {
            case CONSTS.SCENARIO_CONDITIONS.MAIN_SCHEDULE:
              var schd = new ScenarioScheduleCondition();
              Object.assign(schd, result);
              return schd;
            case CONSTS.SCENARIO_CONDITIONS.MAIN_DEVICE:
              var dvc = new ScenarioDeviceEventCondition();
              Object.assign(dvc, result);
              return dvc;
            case CONSTS.SCENARIO_CONDITIONS.MAIN_VIRTUAL:
              var virt = new ScenarioVirtual();
              Object.assign(virt, result);
              return virt;
            default:
              return result;
          }
        }
      }
    }
    return null;
  }

  getOptionalConditions(afterDelayConditions = false) {
    var result = [];
    this.conditions.filter((c) => {
      if (!c.isMain) {
        if (c.checkAfterDelay == afterDelayConditions) {
          switch (c.baseType) {
            case CONSTS.SCENARIO_CONDITIONS.OPTIONAL_AREA_ARMED:
              var arArm = new ScenarioArmedCondition();
              Object.assign(arArm, c);
              result.push(arArm);
              break;
            case CONSTS.SCENARIO_CONDITIONS.OPTIONAL_TIME_RANGE:
              var tmRng = new ScenarioTimeRangeCondition();
              Object.assign(tmRng, c);
              result.push(tmRng);
              break;
            case CONSTS.SCENARIO_CONDITIONS.OPTIONAL_DEVICE_STATE:
              var dvcStt = new ScenarioDeviceStateCondition();
              Object.assign(dvcStt, c);
              result.push(dvcStt);
              break;
            case CONSTS.SCENARIO_CONDITIONS.OPTIONAL_USER_DEFINED_STATE:
              var usrStt = new ScenarioUserDefinedStateCondition();
              Object.assign(usrStt, c);
              result.push(usrStt);
              break;
            default:
              result.push(c);
              break;
          }
        }
      }
    });

    return result;
  }

  getActions() {
    var result = [];
    if (this.actions.length > 0) {
      for (var i in this.actions) {
        var act = new ScenarioAction();
        Object.assign(act, this.actions[i]);
        result.push(act);
      }
    }
    return result.sort((a, b) => (a.order || 0) - (b.order || 0));
  }

  getActionsCount() {
    var count =
      this.actions.length +
      this.areaStateActions.length +
      this.runScenarioActions.length;

    return count;
  }

  getAllActions() {
    var actions = this.getActions();
    var areaStateActions = this.getAreaStateActions();
    var runScenarioActions = this.getRunScenarioActions();
    var actionsToSend = [];

    actions.forEach((a) => actionsToSend.push(a));
    areaStateActions.forEach((a) => actionsToSend.push(a));
    runScenarioActions.forEach((a) => actionsToSend.push(a));

    //   ...actions,
    //   ...areaStateActions,
    //   ...runScenarioActions,
    // ]

    actionsToSend.sort((a, b) => (a.order || 0) - (b.order || 0));

    return actionsToSend;
  }
  getActionReverse() {
    var actions = this.getActions();
    var areaStateActions = this.getAreaStateActions();
    var actionsToSend = [];

    actions.forEach((a) => actionsToSend.push(a));
    areaStateActions.forEach((a) => actionsToSend.push(a));

    //   ...actions,
    //   ...areaStateActions,
    // ]

    actionsToSend.sort((a, b) => (a.order || 0) - (b.order || 0));

    return actionsToSend;
  }

  getAreaStateActions() {
    var result = [];
    if (this.areaStateActions.length > 0) {
      for (var i in this.areaStateActions) {
        var act = new ScenarioAreaStateAction();
        Object.assign(act, this.areaStateActions[i]);
        result.push(act);
      }
    }
    return result;
  }

  getRunScenarioActions() {
    var result = [];
    if (this.runScenarioActions.length > 0) {
      for (var i in this.runScenarioActions) {
        var act = new ScenarioRunScenarioAction();
        Object.assign(act, this.runScenarioActions[i]);
        result.push(act);
      }
    }
    return result;
  }

  reOrderActions(from = 0, to = 0) {
    if (from == to) return;

    var actions = this.getAllActions();
    if (to < 0 || to >= actions.length) return;

    if (from < to) {
      // change order of all items in middle section
      actions[from].order = actions[to].order;
      for (let i = from + 1; i <= to; i++) {
        actions[i].order--;
      }
    } else {
      actions[from].order = actions[to].order;
      for (let i = to; i <= from - 1; i++) {
        actions[i].order++;
      }
    }

    actions.sort((a, b) => (a.order || 0) - (b.order || 0));

    this.actions = [];
    this.areaStateActions = [];
    this.runScenarioActions = [];
    for (let i = 0; i < actions.length; i++) {
      const action = actions[i];

      if (ScenarioAction.prototype.isPrototypeOf(action)) {
        this.actions.push(action);
      } else if (ScenarioAreaStateAction.prototype.isPrototypeOf(action)) {
        this.areaStateActions.push(action);
      } else if (ScenarioRunScenarioAction.prototype.isPrototypeOf(action)) {
        this.runScenarioActions.push(action);
      }
    }
  }

  findConditionById = (id, baseType) => {
    for (var i in this.conditions) {
      if (
        id &&
        (this.conditions[i].id == id || this.conditions[i].tempId == id) &&
        this.conditions[i].baseType == baseType
      ) {
        return this.conditions[i];
      } else if (this.conditions[i].tempId == id) {
        return this.conditions[i];
      }
    }
  };

  addMainCondition() {
    return {
      addSchedule: () => {
        return {
          addDailySchedule: (time, daysOfWeek) => {
            var daily = new ScenarioScheduleCondition(
              CONSTS.SCENARIO_CONDITIONS.MAIN_SCHEDULE
            );
            daily.id = 0;
            daily.isMain = true;
            daily.scheduleType = "daily";
            daily.time = time;
            daily.scheduleDaysOfWeek = daysOfWeek;
            this.conditions.push(daily);
            this._mainConditionType = CONSTS.SCENARIO_CONDITIONS.MAIN_SCHEDULE;
          },
          addCustomSchedule: (time, repeatType, repeatInterval) => {
            var custom = new ScenarioScheduleCondition(
              CONSTS.SCENARIO_CONDITIONS.MAIN_SCHEDULE
            );
            custom.id = 0;
            custom.isMain = true;
            daily.scheduleType = "custom";
            custom.time = time;
            custom.customRepeatType = repeatType;
            custom.customRepeatInterval = repeatInterval;
            this.conditions.push(custom);
            this._mainConditionType = CONSTS.SCENARIO_CONDITIONS.MAIN_SCHEDULE;
          },
        };
      },
      addDeviceEvent: () => {
        return {
          addBooleanEvent: (
            deviceType,
            deviceId,
            deviceUId,
            deviceName,
            eventName,
            eventType,
            expected
          ) => {
            var boolEvent = new ScenarioDeviceEventCondition(
              CONSTS.SCENARIO_CONDITIONS.MAIN_DEVICE
            );
            boolEvent.id = 0;
            boolEvent.deviceType = deviceType;
            boolEvent.deviceId = deviceId;
            boolEvent.deviceUId = deviceUId;
            boolEvent.deviceName = deviceName;
            boolEvent.eventName = eventName;
            boolEvent.eventType = eventType;
            boolEvent.expectedBinaryValue = expected;
            this.conditions.push(boolEvent);
            this._mainConditionType = CONSTS.SCENARIO_CONDITIONS.MAIN_DEVICE;
          },
          addRangeEvent: (
            deviceType,
            deviceId,
            deviceUId,
            deviceName,
            eventName,
            eventType,
            min,
            max
          ) => {
            var rangeEvent = new ScenarioDeviceEventCondition(
              CONSTS.SCENARIO_CONDITIONS.MAIN_DEVICE
            );
            rangeEvent.id = 0;
            rangeEvent.deviceType = deviceType;
            rangeEvent.deviceId = deviceId;
            rangeEvent.deviceUId = deviceUId;
            rangeEvent.deviceName = deviceName;
            rangeEvent.eventName = eventName;
            rangeEvent.eventType = eventType;
            rangeEvent.minExpectedRange = min;
            rangeEvent.maxExpectedRange = max;
            this.conditions.push(rangeEvent);
            this._mainConditionType = CONSTS.SCENARIO_CONDITIONS.MAIN_DEVICE;
          },
          addVoidEvent: (
            deviceType,
            deviceId,
            deviceUId,
            deviceName,
            areaId,
            areaUId,
            areaName,
            listenerName,
            eventName,
            eventType,
            parameterNames = [],
            parameterValues = [],
            parameterTypes = []
          ) => {
            var voidEvent = new ScenarioDeviceEventCondition(
              CONSTS.SCENARIO_CONDITIONS.MAIN_DEVICE
            );
            voidEvent.id = 0;
            voidEvent.deviceType = deviceType;
            voidEvent.deviceId = deviceId;
            voidEvent.deviceUId = deviceUId;
            voidEvent.deviceName = deviceName;
            voidEvent.areaId = areaId;
            voidEvent.areaUId = areaUId;
            voidEvent.areaName = areaName;
            voidEvent.listenerName = listenerName;
            voidEvent.eventName = eventName;
            voidEvent.eventType = eventType;
            voidEvent.parameterNames = parameterNames;
            voidEvent.parameterValues = parameterValues;
            voidEvent.parameterTypes = parameterTypes;
            this.conditions.push(voidEvent);
            this._mainConditionType = CONSTS.SCENARIO_CONDITIONS.MAIN_DEVICE;
          },
        };
      },
      addVirtual: (iconName) => {
        var virtual = new ScenarioVirtual();
        if (iconName) {
          virtual.iconName = iconName;
        }
        virtual.id = 0;
        this.conditions.push(virtual);
        this._mainConditionType = CONSTS.SCENARIO_CONDITIONS.MAIN_VIRTUAL;
      },
    };
  }

  addOptionalCondition() {
    return {
      addDeviceState: (
        areaId,
        areaUId,
        areaName,
        listenerName,
        stateName,
        argNames,
        argValues,
        deviceType,
        deviceId,
        deviceUId,
        deviceName,
        checkAfterDelay
      ) => {
        var deviceState = new ScenarioDeviceStateCondition();
        deviceState.areaId = areaId;
        deviceState.areaUId = areaUId;
        deviceState.areaName = areaName;
        deviceState.deviceType = deviceType;
        deviceState.listenerName = listenerName;
        deviceState.stateName = stateName;
        deviceState.argNames = argNames;
        deviceState.argValues = argValues;
        deviceState.deviceId = deviceId;
        deviceState.deviceUId = deviceUId;
        deviceState.deviceName = deviceName;
        deviceState.checkAfterDelay = checkAfterDelay || false;

        this.conditions.push(deviceState);
      },
      addTimeRange: (start, end, checkAfterDelay) => {
        var timeRange = new ScenarioTimeRangeCondition();
        timeRange.timeStateStart = start;
        timeRange.timeStateEnd = end;
        timeRange.checkAfterDelay = checkAfterDelay;
        this.conditions.push(timeRange);
      },
      addAreaArmedState: (
        areaId,
        areaUId,
        areaName,
        expected,
        checkAfterDelay
      ) => {
        var armed = new ScenarioArmedCondition(
          CONSTS.SCENARIO_CONDITIONS.OPTIONAL_AREA_ARMED
        );
        armed.areaIdArmCheck = areaId;
        armed.areaUIdArmCheck = areaUId;
        armed.areaNameArmCheck = areaName;
        armed.areaArmCheckExpected = expected;
        armed.checkAfterDelay = checkAfterDelay;
        this.conditions.push(armed);
      },
      addAreaUserDefinedState: (
        areaId,
        areaUId,
        areaName,
        stateId,
        stateUId,
        stateName,
        checkAfterDelay
      ) => {
        var userDefinedState = new ScenarioUserDefinedStateCondition(
          CONSTS.SCENARIO_CONDITIONS.OPTIONAL_USER_DEFINED_STATE
        );
        userDefinedState.areaId = areaId;
        userDefinedState.areaUId = areaUId;
        userDefinedState.areaName = areaName;
        userDefinedState.stateId = stateId;
        userDefinedState.stateUId = stateUId;
        userDefinedState.stateName = stateName;
        userDefinedState.checkAfterDelay = checkAfterDelay;
        userDefinedState.expectedActivation = true;

        this.conditions.push(userDefinedState);
      },
    };
  }

  removeCondition(id, type) {
    if (this.conditions && this.conditions.length) {
      var itemIndex = null;
      for (var c in this.conditions) {
        if (
          Number(id) > 0 &&
          this.conditions[c].id == id &&
          this.conditions[c].baseType == type
        ) {
          //this.conditions.splice(c, 1);
          itemIndex = c;
          break;
        } else if (
          this.conditions[c].tempId == id &&
          this.conditions[c].baseType == type
        ) {
          //this.conditions.splice(c, 1);
          itemIndex = c;
          break;
        }
      }
      if (itemIndex >= 0) {
        this.conditions.splice(itemIndex, 1);

        // mark as removed to delete from db
        if (Number(id) > 0) {
          this.markAsRemoved(id, "condition", type);
        }
      }
    }
  }

  setTimeRangeCondition(id, time, rangeType) {
    var c = this.findConditionById(id, "timeRange");
    if (c) {
      if (rangeType == "start") {
        c.timeStateStart = time;
      } else if (rangeType == "end") {
        c.timeStateEnd = time;
      }
    }
  }

  addAction(
    areaId,
    areaUId,
    areaName,
    managerName,
    actionName,
    parameterTypes = [],
    customId = 0,
    customUId = "",
    parameters = [],
    deviceId = 0,
    deviceUId = "",
    deviceName = "",
    parametersAlt = []
  ) {
    var act = new ScenarioAction(customId, customUId);
    act.areaId = areaId;
    act.areaUId = areaUId;
    act.areaName = areaName;
    act.manager = managerName;
    act.action = actionName;
    act.parameterTypes = parameterTypes;
    act.parameters = parameters;
    act.parametersAlt = parametersAlt;
    act.deviceId = deviceId;
    act.deviceUId = deviceUId;
    act.deviceName = deviceName;
    act.order = this.getMaxActionOrder() + 1;
    this.actions.push(act);
  }

  addAreaStateAction(
    areaId,
    areaUId,
    areaName,
    stateId,
    stateUId,
    stateName,
    action,
    manager,
    shouldOverrideAutoDisable,
    autoDisableOverrideType,
    autoDisableOverrideDuration
  ) {
    // check for duplicate
    if (this.areaStateActions.some((arSt) => arSt.stateId == stateId)) {
      return;
    }

    var areaState = new ScenarioAreaStateAction();
    areaState.areaId = areaId;
    areaState.areaUId = areaUId;
    areaState.areaName = areaName;
    areaState.action = action;
    areaState.manager = manager;
    areaState.autoDisableIntervalDuration = autoDisableOverrideDuration;
    areaState.autoDisableIntervalType = autoDisableOverrideType;
    areaState.shouldOverrideAutoDisable = shouldOverrideAutoDisable;
    areaState.stateId = stateId;
    areaState.stateUId = stateUId;
    areaState.stateName = stateName;
    areaState.order = this.getMaxActionOrder() + 1;

    this.areaStateActions.push(areaState);
  }

  updateAreaStateAction(model) {
    if (model) {
      //var areaState = new ScenarioAreaStateAction(model.tempId);
      var newCollection = [...this.areaStateActions];
      for (let i = 0; i < newCollection.length; i++) {
        if (
          (model.id != 0 && newCollection[i].id == model.id) ||
          newCollection[i].tempId == model.tempId
        ) {
          newCollection[i] = ScenarioAreaStateAction.parse(model);
          this.areaStateActions = [...newCollection];
          break;
        }
      }
    }
  }

  updateAreaStateAutoDisable(
    id,
    tempId,
    shouldOverrideAutoDisable = false,
    autoDisableIntervalDuration = 0,
    autoDisableIntervalType = "second"
  ) {
    for (let i = 0; i < this.areaStateActions.length; i++) {
      if (
        (id != 0 && this.areaStateActions[i].id == id) ||
        this.areaStateActions[i].tempId == tempId
      ) {
        if (typeof this.areaStateActions[i].updateAutoDisable !== "function") {
          var tst = new ScenarioAreaStateAction();
          Object.assign(tst, this.areaStateActions[i]);
          this.areaStateActions[i] = tst;
        }
        this.areaStateActions[i].updateAutoDisable(
          shouldOverrideAutoDisable,
          autoDisableIntervalDuration,
          autoDisableIntervalType
        );
        break;
      }
    }
  }

  removeAreaStateAction(stateId) {
    var idx = -1;
    if (Number(stateId) > 0) {
      for (let i = 0; i < this.areaStateActions.length; i++) {
        if (this.areaStateActions[i].stateId == stateId) {
          idx = i;
          break;
        }
      }
    }

    var _id = 0;
    if (idx > -1) {
      _id = this.areaStateActions[idx].id;
      this.areaStateActions.splice(idx, 1);
    }

    if (Number(_id)) {
      this.markAsRemoved(_id, "areaStateAction");
    }
  }

  addRunScenarioAction(
    scenarioId = 0,
    scenarioUId = null,
    scenarioName = "",
    reverseEnabled = false
  ) {
    // do not add self entity to avoid infinite loop
    if (this.id == scenarioId || this.id == scenarioUId) {
      return;
    }
    // check for duplicate
    if (
      this.runScenarioActions.some(
        (scn) => scn.scenarioToRunId == scenarioId || scenarioUId
      )
    ) {
      return;
    }

    var act = new ScenarioRunScenarioAction(
      scenarioId,
      scenarioUId,
      scenarioName,
      reverseEnabled
    );

    act.order = this.getMaxActionOrder() + 1;
    this.runScenarioActions.push(act);
  }

  removeRunScenarioAction(scenarioToRunId) {
    if (this.runScenarioActions && Array.isArray(this.runScenarioActions)) {
      var scenarioToRemove = this.runScenarioActions.filter(
        (s) => s.scenarioToRunId == scenarioToRunId
      )[0];
      if (scenarioToRemove) {
        var id = scenarioToRemove.id;
        if (id) {
          this.markAsRemoved(id, "scenario");
        }
        var index = this.runScenarioActions.indexOf(scenarioToRemove);
        this.runScenarioActions.splice(index, 1);
      }
    }
  }

  findActionById = (id) => {
    for (var i in this.actions) {
      if (Number(id) && this.actions[i].id == id) {
        return this.actions[i];
      } else if (this.actions[i].tempId == id) {
        return this.actions[i];
      }
    }
  };

  /**uses to replace temp id generated by client, to id sent from server  */
  updateActionId(tempId, newId) {
    for (var i in this.actions) {
      if (this.actions[i].tempId == tempId) {
        this.actions[i].tempId = newId;
        this.actions[i].id = newId;
        return;
      }
    }
  }

  removeAction(id) {
    var itemIndex = null;
    if (id) {
      for (var i in this.actions) {
        if (
          (Number(id) > 0 && this.actions[i].id == id) ||
          this.actions[i].tempId == id
        ) {
          itemIndex = i;
          break;
        }
      }

      if (itemIndex >= 0) {
        this.actions.splice(itemIndex, 1);

        // mark as removed to delete from db
        if (Number(id) > 0) {
          this.markAsRemoved(id, "action");
        }
      }
    }
  }

  getNotificationSummary = () => {
    let methods = [];
    if (this.notifyBySms) methods.push(translate("scenario.sms"));
    if (this.notifyByPushNotification)
      methods.push(translate("scenario.appNotification"));
    return translate("scenario.summary.notifyBy", {
      method: methods.join(", "),
    });
  };

  markAsRemoved(id, type, conditionType = null) {
    this.removedItems.push({ id, type, conditionType });
  }

  getMaxActionOrder() {
    var maxOrd = 0;
    if (this.runScenarioActions.length > 0) {
      for (let i = 0; i < this.runScenarioActions.length; i++) {
        const action = this.runScenarioActions[i];
        if (action.order > maxOrd) maxOrd = action.order;
      }
    }

    if (this.areaStateActions.length > 0) {
      for (let i = 0; i < this.areaStateActions.length; i++) {
        const action = this.areaStateActions[i];
        if (action.order > maxOrd) maxOrd = action.order;
      }
    }

    if (this.actions.length > 0) {
      for (let i = 0; i < this.actions.length; i++) {
        const action = this.actions[i];
        if (action.order > maxOrd) maxOrd = action.order;
      }
    }

    return maxOrd;
  }

  migrateActionOrders() {
    if (
      this.runScenarioActions.every((s) => s.order <= 1) &&
      this.areaStateActions.every((s) => s.order <= 1) &&
      this.actions.every((s) => s.order <= 1)
    ) {
      var ord = 0;
      if (this.runScenarioActions.length) {
        for (let i = 0; i < this.runScenarioActions.length; i++) {
          ord++;
          var action = this.runScenarioActions[i];
          if (!action.order) action.order = ord;
        }
      }

      if (this.areaStateActions.length) {
        for (let i = 0; i < this.areaStateActions.length; i++) {
          ord++;
          var action = this.areaStateActions[i];
          if (!action.order) action.order = ord;
        }
      }

      if (this.actions.length) {
        for (let i = 0; i < this.actions.length; i++) {
          ord++;
          var action = this.actions[i];
          if (!action.order) action.order = ord;
        }
      }
    }
  }
}
